import snakeCase from 'lodash.snakecase';
import { memo, useMemo } from 'react';

import { cleanUserInput } from '../../lib/cleanUserInput';
import { Item, ItemDescription, Name } from './BusinessItem';

import type { Wws_BasicItem, Wws_StoryItem } from '../../types/graphql';
import DynamicNextImage from '../NextImage/DynamicNextImage';
import { extractParamsFromMediaUrl } from '../../lib/mediaApiUrl';

interface ContentItemProps {
  item: Wws_StoryItem | Wws_BasicItem;
  className?: string | undefined;
}

const ContentItem = ({ item, className }: ContentItemProps) => {
  const { id, type, title, description, photo } = item;

  const mediaUrl = photo?.mediaUrl || '';

  const dangerouslySetInnerHTML = useMemo<{
    __html: string;
  }>(
    () => ({
      __html: cleanUserInput(description),
    }),
    [description]
  );

  const { crop } = extractParamsFromMediaUrl(mediaUrl);

  return (
    <Item
      className={className}
      data-testid={`${snakeCase(type).replace(/_/g, '-')}-${id}`}
    >
      {title ? <Name>{title}</Name> : null}

      {mediaUrl ? (
        <DynamicNextImage
          src={mediaUrl}
          alt={`Picture of ${title}`}
          height={photo?.height || undefined}
          width={photo?.width || undefined}
          crop={crop || undefined}
          rotation={photo?.rotation || undefined}
        />
      ) : null}

      {description ? (
        <ItemDescription dangerouslySetInnerHTML={dangerouslySetInnerHTML} />
      ) : null}
    </Item>
  );
};

export default memo(ContentItem);
